export const OPENAI_RESPONSES_HOST = "openai-responses" as const;
export const ANTHROPIC_HOST = "anthropic" as const;
export const GOOGLE_AI_STUDIO_HOST = "google-ai-studio" as const;
export const AGENT_PLATFORM_HOST = "agent-platform" as const;
export const MISTRAL_HOST = "mistral" as const;
export const FIREWORKS_HOST = "fireworks" as const;
export const XAI_HOST = "xai" as const;
export const NOOP_HOST = "noop" as const;
export const DEEPSEEK_HOST = "deepseek" as const;
// Self-hosted LiteLLM proxy sidecar that fronts Amazon Bedrock (and other
// Bedrock-family providers) behind an OpenAI-compatible chat-completions API.
// Bedrock is an alternate *host* for existing labs (Anthropic/Mistral/DeepSeek),
// not a lab of its own — same pattern as Fireworks hosting DeepSeek-lab models.
export const LITELLM_HOST = "litellm" as const;

const HOSTS = [
  OPENAI_RESPONSES_HOST,
  ANTHROPIC_HOST,
  GOOGLE_AI_STUDIO_HOST,
  AGENT_PLATFORM_HOST,
  MISTRAL_HOST,
  FIREWORKS_HOST,
  XAI_HOST,
  NOOP_HOST,
  DEEPSEEK_HOST,
  LITELLM_HOST,
] as const;
export type Host = (typeof HOSTS)[number];
